import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { portalJwtUrl } from '../configuration';
import useOidcAccessToken from '../component/useOidc';

export default function usePortalJwt(): UseQueryResult<string> {
  const { accessToken: oidcAccessToken } = useOidcAccessToken();
  return useQuery({
    enabled: !!oidcAccessToken,
    queryKey: ['portalJwt'],
    staleTime: 60 * 60 * 1000,
    queryFn: async () => {
      const res = await fetch(portalJwtUrl, {
        headers: {
          Authorization: `Bearer ${oidcAccessToken}`,
        },
      });
      const data = await res.json();
      return data.token as string;
    },
  });
}
